import { render, staticRenderFns } from "./tabletwo.vue?vue&type=template&id=ebfa8370&scoped=true&"
import script from "./tabletwo.vue?vue&type=script&lang=js&"
export * from "./tabletwo.vue?vue&type=script&lang=js&"
import style0 from "./tabletwo.vue?vue&type=style&index=0&id=ebfa8370&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa8370",
  null
  
)

export default component.exports